<template>
	<button
		ref="button"
		role="tab"
		:id="id"
		:tabindex="active ? '0' : '-1'"
		class="ie-focusable"
		:class="[{ active: active && !disabled }, { disabled: disabled }]"
		:aria-label="ariaLabel"
		:aria-selected="active.toString()"
		:aria-controls="controls"
		:data-rpa-tag-id="dataRPATagId"
		@click="select(index)"
		@keydown.enter.prevent="select(index)"
		@keydown.home.prevent="firstTab"
		@keydown.right.prevent="nextTab"
		@keydown.left.prevent="prevTab"
		@keydown.end.prevent="lastTab"
		:disabled="!!disabled"
	>
		<slot />
	</button>
</template>

<script>
export default {
	name: "TabViewButton",

	props: {
		id: {
			type: String,
			required: true
		},

		ariaLabel: {
			type: String
		},

		controls: {
			type: String,
			required: true
		},

		index: {
			type: Number,
			required: true
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		},

		active: {
			type: Boolean,
			required: true
		},

		focused: {
			type: Boolean,
			required: true
		},

		select: {
			type: Function,
			required: true
		},

		firstTab: {
			type: Function,
			required: true
		},

		nextTab: {
			type: Function,
			required: true
		},

		prevTab: {
			type: Function,
			required: true
		},

		lastTab: {
			type: Function,
			required: true
		},

		dataRPATagId: {
			type: String,
			default: ""
		}
	},

	methods: {
		toggleFocus() {
			if (this.focused) {
				this.$refs.button.focus();
			} else {
				this.$refs.button.blur();
			}
		}
	},

	updated() {
		this.toggleFocus();
	}
};
</script>
